import { render, staticRenderFns } from "./DialogConfigurationAddEdit.vue?vue&type=template&id=15df60aa"
import script from "./DialogConfigurationAddEdit.vue?vue&type=script&lang=js"
export * from "./DialogConfigurationAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports